export default "__VITE_ASSET__BXLFqTkw__"